import { createApi, unwrap } from "@tern/api-client";
import { queryOptions } from "@tanstack/react-query";
import type { Schemas } from "@tern/api-client";
export type Team = Schemas["Team"];
export type TeamInput = Schemas["CreateTeam"];
export const accountApi = createApi("");
export const onboardingQuery = queryOptions({
  queryKey: ["account", "onboarding"],
  queryFn: async () => unwrap(await accountApi.GET("/api/onboarding")),
  staleTime: 0,
});
export const createTeam = async (body: TeamInput) =>
  unwrap(await accountApi.POST("/api/onboarding/teams", { body }));
export const saveJobRole = async (job_role: string) =>
  unwrap(
    await accountApi.PUT("/api/onboarding/profile", { body: { job_role } }),
  );
export const completeOnboarding = async (team_id: string) =>
  unwrap(
    await accountApi.POST("/api/onboarding/complete", { body: { team_id } }),
  );
export const lookupTeams = async (query: string) =>
  unwrap(await accountApi.POST("/api/onboarding/lookup", { body: { query } }));
export const requestToJoin = async (team_id: string) =>
  unwrap(
    await accountApi.POST("/api/onboarding/requests", { body: { team_id } }),
  );
export const teamRequestsQuery = (slug: string) =>
  queryOptions({
    queryKey: ["account", "requests", slug],
    queryFn: async () =>
      unwrap(
        await accountApi.GET("/api/onboarding/teams/{slug}/requests", {
          params: { path: { slug } },
        }),
      ),
    retry: false,
  });
export const resolveTeamRequest = async (id: string, approve: boolean) =>
  unwrap(
    await accountApi.POST("/api/onboarding/requests/{id}/resolve", {
      params: { path: { id } },
      body: { approve },
    }),
  );
